import { render, staticRenderFns } from "./AcceleratorDocs.vue?vue&type=template&id=5c407f9c&scoped=true&"
import script from "./AcceleratorDocs.vue?vue&type=script&lang=js&"
export * from "./AcceleratorDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c407f9c",
  null
  
)

export default component.exports